import React from "react";
 import  { useState, useEffect } from 'react';
 import { DataGrid } from '@mui/x-data-grid';
 import './classes/ScoutDirectory.css';
 import { configData } from "../config";
import SalespersonSidebar from "./SalespersonSidebar";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
 import { Link } from '@mui/material';
import ScoutSidebar from "./ScoutSidebar";
import AgentBackendSidebar from "./AgentBackendSidebar";

// import { useMockServer } from '@mui/x-data-grid-generator';

const columns = [
  
  { field: 'name', headerName: 'Name', cellClassName:'name_column',headerClassName:'name_header', renderCell: (params) => (
        <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
          {params.row.name}
        </Link>
        )},
  { field: 'location', headerName: 'Location', cellClassName:'location_column',headerClassName:'location_header', sortable: false,filterable: false},
  { field: 'agent_scout_email', headerName: 'Agency - Scout Email', cellClassName:'agencyemail_column',headerClassName:'agencyemail_header',renderCell: (params) => (
        <a href={'mailto:'+params.row.agent_scout_email} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
          {params.row.agent_scout_email}
        </a>
        )},
];




const ScoutDirectory =() =>{
  /* Pagination, filter config starts here */
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 100 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);   
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
       first_name:''
    });
    const [appliedFormData, setAppliedFormData] = useState({
       first_name:''
      });
const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  const domainName = window.location.host.replace(/^https?:\/\//, '');
    useEffect(() => {
          Promise.all([
             
          ])
          .then(() => {
       
          setIsLoading(false);
          })
      },[]);
      
  React.useEffect(() => {
   const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
      try {
         setIsLoading(true);
      const response = await fetch(app_url+'smwwscout/getdirectorylist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          //formData:formData
          formData:appliedFormData,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };

    fetchData();
   
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change


  /* Pagination, filter config ends here */
const handleSubmit = async (e) => {
  e.preventDefault();
  setPaginationModel({
                 page: 0,
                    pageSize: 100,
                 });
                 setAppliedFormData({ ...formData });
  try {
         setIsLoading(true);
      const response = await fetch(app_url+'smwwscout/getdirectorylist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 100,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount);  // Server should return totalRowCount
  }catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }

  
}; 


 
    return(
      <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main">

          <Helmet><title>Scouts Directory</title></Helmet>
             <div class="left"></div>
               
               <div class="center left-center">
                    <div className="sortflags-container">
                        <div className="scoutdirectory-view-header">
                            <h1>Scouts Directory</h1>
                           
                           
                        </div>
                        <div className="view-filters">
                            <form className="scoutdirectory-filter-form">
                                <div className="scoutdirectory-view-exposed-form">
                                    <div className="scoutdirectory-view-exposed-widgets scoutdirectory-clearfix">
                                        <div id="scoutdirectory-edit-first-name" className="scoutdirectory-views-exposed-widget scoutdirectory-filter-first-name">
                                            <label htmlFor="scoutdirectory-edit-first-name-value"> First Name </label>
                                                <div className="scoutdirectory-views-widget">
                                                    <div className="scoutdirectory-form-item  scoutdirectory-form-textfield  scoutdirectory-form-item-first-name-value">
                                                            <input type="text" id="first_name" name="first_name" size="30" 
                                                            onChange={handleChange} 
                                                            value={formData.first_name}
                                                            maxlength="128" className="scoutdirectory-form-text"/>
                                                    </div>
                                                </div>
                                            </div>
                                                    
                                            <div className="scoutdirectory-views-exposed-widget scoutdirectory-views-submit-button">
                                                <input type="submit" id="scoutdirectory-edit-submit" value="Apply" className="form-submit scoutdirectory-form-submit" onClick={handleSubmit}/>    
                                            </div>


                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="scoutdirectory-view-content">
                            <table className="scoutdirectory-views-table">
                                   <div style={{  width: '100%' }}>
                                          <DataGrid
                                           rows={rows}
                                           columns={columns}
                                           rowCount={rowCount}
                                           paginationMode="server"
                                           sortingMode="server"
                                           filterMode="server"
                                           paginationModel={paginationModel}
                                           onPaginationModelChange={setPaginationModel}
                                           sortModel={sortModel}
                                           onSortModelChange={setSortModel}
                                            filterModel={filterModel}
                                           onFilterModelChange={setFilterModel}
                                           pageSizeOptions={[5, 10, 25,50]}
                                           getRowId={() => crypto.randomUUID()}
                                           getRowHeight={() => 'auto'}
                                           disableColumnFilter 
                                           disableColumnResize={true}
                                       />
    </div>
                            </table>
                        </div>

                    </div>

                </div>
                 <div class="right">
             {/* {domainName === configData.RSMWW_DOMAIN && 
                <SalespersonSidebar/>
              }
              {domainName === configData.RSMWW_SCOUT_DOMAIN && 
                <ScoutSidebar/>
              } */}
                {/* {
                    userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                    userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                    userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)
                      ? <SalespersonSidebar />
    
                      : domainName === configData.RSMWW_AGENCY_DOMAIN &&
                        userLoggedInRoles.includes(configData.ROLE_AGENT)
                      ? <AgentBackendSidebar />
    
                      : domainName === configData.RSMWW_SCOUT_DOMAIN &&
                        userLoggedInRoles.includes(configData.ROLE_SCOUT)
                      ? <ScoutSidebar />
    
                      :  <div>
                    <h1>Quick Links</h1>
                    <ul style={{padding: "0px"}}>
                        <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                        <a href="/smww_pay">
                        <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                        </a>
                        </li>           */}
                        {/* {localStorage.getItem('masquerade') == 1 && (
                            <li>
                            <a className="salesperson-quick_link_anchor" href={/miscellaneous/charge/${drupal_uid}}>
                                Miscellaneous Charge
                            </a>
                            </li>
                        )} */}
                    {/* </ul>
                  </div>
                  } */}
                  <SalespersonSidebar />
        </div>
        
        </div>
      )}
    </>  
    );
};

export default ScoutDirectory;